import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine, faShieldHeart, faUserClock } from "@fortawesome/free-solid-svg-icons";

export const LifeAndInvestment = () => {
    return (
        <>
            {/* Banner */}
            <Container
                fluid
                style={{
                    backgroundColor: "#1e1e3f",
                    color: "#fff",
                    textAlign: "center",
                    padding: "4rem 2rem",
                }}
            >
                <h1 style={{ fontSize: "2.8rem", fontWeight: "700" }}>Life & Investment Solutions</h1>
                <p style={{ fontSize: "1.2rem", marginTop: "1rem", maxWidth: "700px", margin: "0 auto" }}>
                    Secure your future, build your legacy — we help you plan, protect, and grow.
                </p>
            </Container>

            {/* Section 1: Importance of Investing */}
            <Container className="my-5">
                <Row className="align-items-center">
                    <Col md={6}>
                        <div style={{ fontSize: "3rem", color: "#ffcc00", marginBottom: "1rem" }}>
                            <FontAwesomeIcon icon={faChartLine} />
                        </div>
                        <h2 style={{ color: "#1e1e3f", fontWeight: "600", marginBottom: "1rem" }}>
                            Why Investing Matters
                        </h2>
                        <p style={{ fontSize: "1.1rem", color: "#333" }}>
                            Investing is not just about growing wealth — it's about achieving your financial goals, from buying your dream home to funding your children’s education. With the right strategy, your money works for you over time, outpacing inflation and building security.
                        </p>
                    </Col>
                    <Col md={6}>
                        <div
                            style={{
                                backgroundColor: "#f4f4f8",
                                borderRadius: "20px",
                                padding: "2rem",
                                boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            <h5 style={{ fontWeight: "600", marginBottom: "1rem", color: "#1e1e3f" }}>Our Investment Services Include:</h5>
                            <ul style={{ listStyle: "none", padding: 0 }}>
                                <li>✔ Unit Trust Portfolios</li>
                                <li>✔ Endowments & Tax-Free Savings</li>
                                <li>✔ Offshore Investment Planning</li>
                                <li>✔ Retirement Annuities</li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </Container>

            {/* Section 2: Importance of Life Cover */}
            <Container fluid style={{ backgroundColor: "#1e1e3f", padding: "4rem 2rem", color: "#fff" }}>
                <Container>
                    <Row className="align-items-center">
                        <Col md={6}>
                            <div style={{ fontSize: "3rem", color: "#ffcc00", marginBottom: "1rem" }}>
                                <FontAwesomeIcon icon={faShieldHeart} />
                            </div>
                            <h2 style={{ fontWeight: "600", marginBottom: "1rem" }}>The Value of Life Insurance</h2>
                            <p style={{ fontSize: "1.1rem" }}>
                                Life insurance protects your loved ones from financial uncertainty should the unexpected happen. Whether it's income replacement, debt settlement, or estate planning, life cover gives peace of mind and a lasting legacy.
                            </p>
                        </Col>
                        <Col md={6}>
                            <div
                                style={{
                                    backgroundColor: "#ffffff",
                                    borderRadius: "20px",
                                    padding: "2rem",
                                    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
                                    color: "#1e1e3f",
                                }}
                            >
                                <h5 style={{ fontWeight: "600", marginBottom: "1rem" }}>Tailored Life Cover Options:</h5>
                                <ul style={{ listStyle: "none", padding: 0 }}>
                                    <li>✔ Term Life Insurance</li>
                                    <li>✔ Whole Life & Universal Cover</li>
                                    <li>✔ Critical Illness Cover</li>
                                    <li>✔ Disability Income Protection</li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>

            {/* Section 3: Retirement Planning */}
            <Container className="my-5">
                <Row className="align-items-center">
                    <Col md={6}>
                        <div style={{ fontSize: "3rem", color: "#ffcc00", marginBottom: "1rem" }}>
                            <FontAwesomeIcon icon={faUserClock} />
                        </div>
                        <h2 style={{ color: "#1e1e3f", fontWeight: "600", marginBottom: "1rem" }}>
                            Secure Your Retirement
                        </h2>
                        <p style={{ fontSize: "1.1rem", color: "#333" }}>
                            Retirement isn't just about stopping work — it's about maintaining your lifestyle, travelling, and enjoying life on your own terms. With a custom-built retirement plan, you ensure comfort and freedom well into your golden years.
                        </p>
                    </Col>
                    <Col md={6}>
                        <div
                            style={{
                                backgroundColor: "#f4f4f8",
                                borderRadius: "20px",
                                padding: "2rem",
                                boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            <h5 style={{ fontWeight: "600", marginBottom: "1rem", color: "#1e1e3f" }}>
                                We Help You Plan For:
                            </h5>
                            <ul style={{ listStyle: "none", padding: 0 }}>
                                <li>✔ Retirement Annuities (RA)</li>
                                <li>✔ Pension & Provident Fund Transfers</li>
                                <li>✔ Living & Guaranteed Annuities</li>
                                <li>✔ Tax-efficient Withdrawals</li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </Container>

            {/* Contact Section */}
            <Container className="text-center my-5">
                <div
                    style={{
                        backgroundColor: "#1e1e3f",
                        color: "#fff",
                        padding: "2.5rem",
                        borderRadius: "20px",
                        maxWidth: "800px",
                        margin: "0 auto",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                    }}
                >
                    <h3 style={{ fontWeight: "600", marginBottom: "1rem" }}>Speak to a Broker Today</h3>
                    <p style={{ fontSize: "1.1rem", marginBottom: "1.5rem" }}>
                        Let us help you find the right investment and protection strategy for your future.
                    </p>
                    <p style={{ fontSize: "1rem", marginBottom: "1rem", color: "#ffcc00" }}>
                        📞 012 334 5678 | 📧 info@logosbrokers.co.za
                    </p>
                    <Button
                        variant="light"
                        href="https://wa.me/YOUR_PHONE_NUMBER"
                        style={{
                            borderRadius: "25px",
                            padding: "0.6rem 1.5rem",
                            fontWeight: "500",
                            color: "#1e1e3f",
                        }}
                    >
                        Message on WhatsApp
                    </Button>
                </div>
            </Container>
        </>
    );
};
